//custom error messages

const getMinLengthErrorMessage = () => {
  return "this field should be at least 3 caracter long !";
};

const getMaxLengthErrorMessage = () => {
  return "this field should be at most 50 caracter long !";
};

const getNumberErrorMessage = () => {
  return "invalid number !";
};

const getRequiredErrorMessage = () => {
  return "this field is required !";
};

module.exports = {
  getMinLengthErrorMessage,
  getMaxLengthErrorMessage,
  getNumberErrorMessage,
  getRequiredErrorMessage
};



// WEBPACK FOOTER //
// ./src/utils/formValidation/ErrorMessages.js